// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyArzgDrmPUx3rGR6ASWay6y9SMvKSyev-8',
    authDomain: 'boook-1fed7.firebaseapp.com',
    databaseURL: 'https://boook-1fed7.firebaseio.com',
    projectId: 'boook-1fed7',
    storageBucket: 'boook-1fed7.appspot.com',
    messagingSenderId: '619797605773',
  },
  url: 'https://us-central1-boook-1fed7.cloudfunctions.net/boook',
  urlLocal: 'http://localhost:5001/boook-1fed7/us-central1/boook',
  urlStorage: 'https://firebasestorage.googleapis.com/v0/b',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
